enum ACTIVITY_TYPE {
    PARCEL_EXPORT = "PARCEL_EXPORT",
    COLLECTION_REQUEST_EXPORT = "COLLECTION_REQUEST_EXPORT",
    ADDRESS_EXPORT = "ADDRESS_EXPORT",
    LOGIN_AS_OTHER = "LOGIN_AS_OTHER",
    SESSION_CHANGE = "SESSION_CHANGE",
    OFFICE_EDIT = "OFFICE_EDIT",
    PARCEL_RANGE_ADD = "PARCEL_RANGE_ADD"
}

const activityTypeList = Object.values(ACTIVITY_TYPE)

export default ACTIVITY_TYPE
export {
    activityTypeList
}
